<template>
  <div class="content-visibility-reco bg-[#E2E5ED] p-4 sm:p-2 sm:pt-4 sm:rounded-md">
    <div class="flex items-center mb-4 pl-1">
      <OIcon icon="trend-arrow" svg-class="text-[#424242]" class="mr-2" />
      <div class="font-medium text-24 text-primary-100">{{ $t('news-page.special-contents') }}</div>
    </div>
    <div class="flex flex-wrap justify-between mb-2">
      <RecommendationCard
        v-for="(article, index) in articles"
        :key="article._id"
        :article="article"
        class="mb-2"
        :variant="articles.length > 4 && index === 2 ? 'big' : 'default'"
        :class="{ 'recommendation-card': articles.length < 5 ? true : index !== 2 }"
        :data-layer="{ name: 'Haber Detay - Sana Özel', position: index + 1 }"
        :onedio-event="{ type: 'sidebar', category: 'Ara kartlar', action: 'Click', label: 'Sana Özel Seçtiklerimiz' }"
      />
    </div>
    <OLink class="bg-o-blue text-white py-3.75 w-full rounded-md flex u-center text-md font-bold leading-18" pure href="/sanaozel">
      {{ $t('main.more-contents-for-you') }}
      <OIcon icon="arrow-right-white" class="ml-2.5" svg-class="w-3 h-3" />
    </OLink>
  </div>
</template>
<script>
import { defineComponent, onMounted, ref, useContext, inject, computed } from '@nuxtjs/composition-api';
import RecommendationCard from '@/modules/card/templates/article/RecommendationCard';
import { shuffle } from 'lodash';
import { useDevice } from '@/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { OLink, OIcon } from '~/modules/common/components/ui';
import { eventBus } from '~/modules/common/utils/eventBus';

export default defineComponent({
  components: {
    RecommendationCard,
    OLink,
    OIcon,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      default: 4,
    },
  },
  setup(props) {
    const { user, isLoggedIn } = useAuth();
    const { isMobile } = useDevice();
    const { $service } = useContext();
    const articles = ref([]);
    const adConfig = inject('adConfig');
    const isSponsored = computed(() => adConfig.value?.decidedMode?.value === 'sponsored');
    onMounted(async () => {
      if (isSponsored.value) {
        const { data: recommendedArticles } =
          adConfig.value?.sponsoredTag?.type === 'tag'
            ? await $service.tag.getTagRandomFeed(adConfig.value?.sponsoredTag?.id, 1, 25)
            : await $service.category.getCategoryRandomFeed(adConfig.value?.sponsoredTag?.id, 1, 25);
        const recommendedArticlesFiltered = recommendedArticles.filter((recoArticle) => props.article._id !== recoArticle._id);
        articles.value = shuffle(recommendedArticlesFiltered).slice(0, props.count);
      } else {
        const anonymUserId = localStorage.getItem('o-oet-ti');
        const userId = isLoggedIn.value ? user.value?._id : JSON.parse(anonymUserId)?.data;
        const { data: recommendedArticles } = await $service.category.getRecommendedArticles({
          userId,
          categories: props.article.breadcrumb[0]?.name,
          placementId: 1,
        });
        const recommendedArticlesFiltered = recommendedArticles.filter((recoArticle) => props.article._id !== recoArticle._id);
        articles.value = shuffle(recommendedArticlesFiltered).slice(0, props.count);
        if (isMobile.value) {
          eventBus.emit('set-navigator-articles', articles.value);
        }
      }
    });
    return {
      articles,
    };
  },
});
</script>
<style lang="scss">
.recommendation-card {
  width: calc(50% - 4px);
}
.content-visibility-reco {
  contain-intrinsic-size: 100px 512px;
  content-visibility: auto;
  @include sm() {
    content-visibility: visible;
  }
}
</style>
